"use strict";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const reportService = {
  getReportTypes: function () {
    return api.get("/Reports", WithToken.headersToken({}, "authTNToken"));
  },
  getReportFields: function (id, cancelToken) {
    return api.get(
      `/Reports/${id}/Fields`,
      WithToken.headersToken(
        {
          cancelToken: cancelToken,
        },
        configuration.cookieName
      )
    );
  },
  getUnitsReport: function (id, options, cancelToken) {
    const params = { startDate: options.startDate, endDate: options.endDate, timeZone: options.timeZone  };

    return api.post(
      `/Reports/${id}/View`,
      options.units,
      WithToken.headersToken(
        {
          params,
          cancelToken: cancelToken,
        },
        configuration.cookieName
      )
    );
  },
  saveReport: function (id, options) {
    return api.post(
      `/Reports/${id}/Save`,
      options,
      WithToken.headersToken(
        {
          params: options,
        },
        configuration.cookieName
      )
    );
  },
  getSavedReports: function (options) {
    return api.get("/SavedReports", WithToken.headersToken({}, configuration.cookieName));
  },
  downloadSavedReport: function (id) {
    return api.post(
      "/SavedReports/" + id,
      {},
      WithToken.headersToken(
        {
          params: { id: id },
          responseType: "blob",
        },
        configuration.cookieName
      )
    );
  },
  deleteReport: function (id) {
    return api.delete(
      "/SavedReports",
      WithToken.headersToken(
        {
          params: { id: id },
        },
        configuration.cookieName
      )
    );
  },
  downloadReport: function (id, options) {
    return api.post(
      `/Reports/${id}/Download`,
      options.units,
      WithToken.headersToken(
        {
          params: options,
          responseType: "blob",
        },
        configuration.cookieName
      )
    );
  },
  getReportFormats: function () {
    return api.get("/Reports/Formats", WithToken.headersToken({}, "authTNToken"));
  },
};

export default reportService;
